/**
 * R01-J's natural-position → tactical-slot candidate table, copied from
 * backend-v2 `PRIMARY_POSITION_SLOT_CANDIDATES`
 * (`src/watchlist/watchlist-pitch/constants/pitch-contract.constants.ts`).
 * Keyed by natural-position code, valued by tactical-slot wire strings in the
 * backend's preference order. Wire strings, not the generated enum: the
 * selection bar and the preference-order state machine read it, and both
 * must stay comparable where a suite partially mocks the generated module.
 * @module features/scouting/constants/primaryPositionSlotCandidates
 */
export const PRIMARY_POSITION_SLOT_CANDIDATES: Readonly<
  Record<string, readonly string[]>
> = {
  GK: ["GK"],
  CB: ["CB", "LCB", "RCB"],
  LCB: ["LCB"],
  RCB: ["RCB"],
  LB: ["LB"],
  RB: ["RB"],
  LWB: ["LWB"],
  RWB: ["RWB"],
  CDM: ["CDM", "LCDM", "RCDM"],
  LDM: ["LCDM"],
  RDM: ["RCDM"],
  CM: ["CM", "LCM", "RCM"],
  LCM: ["LCM"],
  RCM: ["RCM"],
  CAM: ["CAM"],
  LAM: ["LAM"],
  RAM: ["RAM"],
  LM: ["LM"],
  RM: ["RM"],
  LW: ["LW"],
  RW: ["RW"],
  CF: ["ST", "LST", "RST"],
  LCF: ["LST"],
  RCF: ["RST"],
  SS: ["SS"],
};

/**
 * The candidate slots of one natural position. A missing or unknown code has
 * none, which is what the backend does with it.
 * @param code - Natural-position code, or null when the member has none
 * @returns Candidate slots in preference order.
 */
export const slotCandidatesFor = (
  code: string | null | undefined
): readonly string[] => PRIMARY_POSITION_SLOT_CANDIDATES[code ?? ""] ?? [];
